import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1636153279424-cb5d1e00f5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwcG9ydHJhaXQlMjBlZGl0b3JpYWwlMjBiZWF1dHl8ZW58MHx8fHwxNzg3ODIwNDMyfDA&ixlib=rb-4.1.0&q=85&w=1200";

export default function About() {
  return (
    <section id="about" className="px-6 py-24 lg:px-12 lg:py-32" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 lg:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative lg:col-span-5"
        >
          <div className="absolute -right-6 -bottom-6 h-full w-full bg-[#F3E6E1] border border-[#26221F]/15" aria-hidden="true" />
          <div className="relative overflow-hidden border border-[#26221F]/20">
            <img
              src={ABOUT_IMG}
              alt="Editorial portrait of a woman defining her own label"
              loading="lazy"
              className="aspect-[3/4] w-full object-cover"
              data-testid="about-image"
            />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6 lg:col-start-7"
        >
          <p className="mb-6 text-xs font-semibold uppercase tracking-[0.4em] text-[#6F665F]">
            About Us
          </p>
          <h2 className="font-display text-4xl leading-tight tracking-tight md:text-6xl" data-testid="about-heading">
            A house built on <em className="italic text-[#D8AFA4]">her</em> terms
          </h2>
          <div className="mt-8 space-y-6 text-base leading-relaxed text-[#6F665F] md:text-lg" data-testid="about-copy">
            <p>
              Her Label begins with a simple belief: style is not something handed
              down — it is something claimed. We are a luxury press-on nail house,
              but what we really make is permission. Permission to change your mind,
              your mood, your manicure — as often as you like.
            </p>
            <p>
              Every set is designed like couture: considered, crafted, and finished
              by hand. Press-ons with a kit for the ritualist, UV-cured sets for the
              perfectionist, wraps for the minimalist, and fully bespoke designs for
              the woman who refuses to be categorised.
            </p>
            <p className="font-display text-xl italic text-[#26221F] md:text-2xl">
              Because the only label worth wearing is a label of her own.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
